import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuthContext } from '@providers/AuthProvider';
import { VsLogo } from '@components/Logo';
import { DesktopTutorialVideo } from '@modals/DesktopTutorialVideo';

import { DownloadDesktopCard } from './components/DownloadDesktop';
import { WelcomeAndMenu } from './components/WelcomeAndMenu';

export const Sidebar = () => {
  const [isDesktopTutorialOpen, setIsDesktopTutorialOpen] = useState(false);
  const location = useLocation();
  const { me } = useAuthContext();
  const isVsAdmin = me?.roles?.includes('ROLE_VS_ADMIN');
  const isVsAdminSection = location.pathname.startsWith('/admin/');

  return (
    <div className="h-full">
      <div className="bg-surface w-full shadow-[5px_0_15px_var(--color-shadow)] px-2.5 pt-5 pb-2.5 overflow-y-auto overflow-x-hidden flex flex-col items-center h-full">
        <div className="mb-2.5 h-20">
          <VsLogo />
        </div>

        <WelcomeAndMenu />

        {!isVsAdmin || !isVsAdminSection ? (
          <>
            <DownloadDesktopCard />
            <DesktopTutorialVideo isOpen={isDesktopTutorialOpen} onClose={() => setIsDesktopTutorialOpen(false)} />
          </>
        ) : null}
      </div>
    </div>
  );
};
